import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuPaintingRoundsView } from "src/tenantCustomizations/tenants/mellano/views/luukku/production/MellanoLuukkuPaintingRoundsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/paintingRounds")({
	staticData: { title: "Maalauskierrokset", legacyViewKey: "mellanoLuukkuPaintingRoundsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuPaintingRoundsView />;
}
